"use client";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import CloseIcon from "../../../../public/Images/x.svg";
import ArrowDown from "../../../../public/Images/arrowDownDrawer.svg";
import ArrowUp from "../../../../public/Images/arrowupDrawer.svg";

import "./drawer.style.css";
import { GetServices } from "@/action/action";

const TRANSITION_MS = 1000;

export default function Drawer({
  isOpen = false,
  onClose = () => { },
  services,
  fetchServices = true,
}) {
  const [serviceData, setServiceData] = useState(services ?? []);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const servicesRef = useRef(null);
  const [servicesHeight, setServicesHeight] = useState(0);

  const [mounted, setMounted] = useState(false);
  const [openClass, setOpenClass] = useState(false);

  useEffect(() => {
    let timeout;

    if (isOpen) {
      setMounted(true);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setOpenClass(true);
        });
      });
    } else {
      requestAnimationFrame(() => {
        setOpenClass(false);
        timeout = setTimeout(() => {
          setMounted(false);
        }, TRANSITION_MS);
      });
    }

    return () => clearTimeout(timeout);
  }, [isOpen]);



  useEffect(() => {
    if (!fetchServices || services) return;
    GetServices({
      callback: (res) => {
        if (res) setServiceData(res);
      },
    });
  }, [fetchServices, services]);

  useEffect(() => {
    if (services) setServiceData(services);
  }, [services]);

  // Lock body scroll while visible
  useEffect(() => {
    if (!mounted) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = prev);
  }, [mounted]);

  // ESC to close
  useEffect(() => {
    if (!mounted) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [mounted, onClose]);

  const toggleServices = () => {
    const next = !isServicesOpen;
    setIsServicesOpen(next);
    if (next && servicesRef.current) {
      setServicesHeight(servicesRef.current.scrollHeight);
    } else {
      setServicesHeight(0);
    }
  };

  useEffect(() => {
    if (isServicesOpen && servicesRef.current) {
      setServicesHeight(servicesRef.current.scrollHeight);
    }
  }, [serviceData, isServicesOpen]);

  if (!mounted && !openClass) return null;


  return (
    <div
      className={`drawerRoot ${openClass ? "open" : ""}`}
      role="dialog"
      aria-modal="true"
      aria-hidden={!openClass}
    >
      {/* Overlay */}
      <button className="drawerOverlay" aria-label="Close menu" onClick={onClose} />

      {/* Panel */}
      <aside className="drawerPanel">
        <div className="drawerHeader">
          <button className="closeBtn" onClick={onClose} aria-label="Close">
            <Image src={CloseIcon} alt="Close" width={28} height={28} />
          </button>
        </div>

        <nav className="drawerNav">
          <Link href="/home" className="navLink" onClick={onClose}>Home</Link>

          <div className="servicesBlock">
            <button
              className="servicesToggle"
              onClick={toggleServices}
              aria-expanded={isServicesOpen}
              aria-controls="services-list"
            >
              <span style={{ color: 'white' }}>Services</span>
              <Image
                src={isServicesOpen ? ArrowUp : ArrowDown}
                alt={isServicesOpen ? "Collapse" : "Expand"}
                width={20}
                height={20}
                className={`arrow ${isServicesOpen ? "rot" : ""}`}
              />
            </button>

            <div
              id="services-list"
              className="servicesListWrapper"
              style={{ height: servicesHeight }}
            >
              <ul className="servicesList" ref={servicesRef}>
                {serviceData?.map((item) => (
                  <li key={item.id} className="serviceItem">
                    <Link
                      href={`/services/${item.id}`}
                      className="serviceLink"
                      onClick={onClose}
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <Link href="/about_us" className="navLink" onClick={onClose}>About Us</Link>
          <Link href="/projects" className="navLink" onClick={onClose}>Portfolio</Link>
          <Link href="/blog" className="navLink" onClick={onClose}>Blog</Link>

          <Link href="/introCallPage" className="discover-button drawer-book-btn" onClick={onClose}>
            Book intro call
          </Link>
        </nav>
      </aside>
    </div>
  );
}
